export const RecruitmentSortType = {
  CREATED_AT: 'createdAt',
  NAME: 'name',
} as const

export type RecruitmentSortTypeValue =
  (typeof RecruitmentSortType)[keyof typeof RecruitmentSortType]

export const RecruitmentSortTypeLabel: { [key: string]: string } = {
  [RecruitmentSortType.CREATED_AT]: '新着順',
  [RecruitmentSortType.NAME]: '名前順',
}
